export default class MemberStatusJwtService {
  axiosIns = null;

  jwtConfig = null;

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(
      this.jwtConfig.main.memberStatusEndpoint,
      payload
    );
  }

  update(id, payload = {}) {
    return this.axiosIns.put(
      `${this.jwtConfig.main.memberStatusEndpoint}/${id}`,
      payload
    );
  }

  delete(id) {
    return this.axiosIns.delete(
      `${this.jwtConfig.main.memberStatusEndpoint}/${id}`
    );
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.memberStatusEndpoint, {
      params,
    });
  }
}
